export function calculatePositions({
  setTriggerPos,
  setTooltipPos,
  trigger,
  tooltip,
  pointerPlacement,
  scrollEvent,
  fixed
}) {
  const triggerWidth = trigger?.clientWidth ?? 0;
  const triggerHeight = trigger?.clientHeight ?? 0;
  const triggerCenter = triggerWidth / 2;
  const tooltipWidth = tooltip?.clientWidth ?? 0;
  const tooltipHeight = tooltip?.clientHeight ?? 0;
  const tooltipArrowCenter = tooltipWidth / 2;
  const tooltipCenter = (tooltipWidth - triggerWidth) / 2;
  const offset = 24;
  const scrollTop = fixed && scrollEvent?.scrollTop ? scrollEvent?.scrollTop * -1 : 0;
  
  switch (pointerPlacement) {
    case "top-left":
      setTriggerPos({ placement: "top", xOffset: triggerCenter, yOffset: 0 });
      setTooltipPos({
        transform: `translateY(${offset + scrollTop}px)`,
      });
      return;
    case "top-center":
      setTriggerPos({
        placement: "top",
        xOffset: tooltipArrowCenter,
        yOffset: 0,
      });
      setTooltipPos({
        transform: `translate(-${tooltipCenter}px, ${offset + scrollTop}px)`,
      });
      return;
    case "top-right":
      setTriggerPos({
        placement: "top",
        xOffset: tooltipWidth - triggerCenter,
        yOffset: 0,
      });
      setTooltipPos({
        transform: `translate(-${tooltipWidth - triggerWidth}px, ${offset + scrollTop}px)`,
      });
      return;
    case "middle-left":
      setTriggerPos({
        placement: "left",
        xOffset: 0,
        yOffset: (tooltipHeight / 2) - (offset / 2),
      });
      setTooltipPos({
        transform: `translate(${triggerWidth + offset}px, -${(tooltipHeight / 2) + offset}px)`,
      });
      return;
    case "middle-right":
      setTriggerPos({
        placement: "right",
        xOffset: 0,
        yOffset: (tooltipHeight / 2) - (offset / 2),
      });
      setTooltipPos({
        transform: `translate(-${tooltipWidth + offset}px, -${(tooltipHeight / 2) + offset}px)`,
      });
      return;
    case "bottom-left":
      setTriggerPos({
        placement: "bottom",
        xOffset: tooltipArrowCenter / 2,
        yOffset: 0,
      });
      setTooltipPos({
        transform: `translate(0px, -${tooltipHeight + triggerHeight + offset}px)`,
      });
      return;
    case "bottom-center":
      setTriggerPos({
        placement: "bottom",
        xOffset: tooltipArrowCenter,
        yOffset: 0,
      });
      setTooltipPos({
        transform: `translate(-${tooltipCenter}px, -${tooltipHeight + triggerHeight + offset}px)`,
      });
      return;
    case "bottom-right":
      setTriggerPos({
        placement: "bottom",
        xOffset: triggerWidth + triggerCenter - offset / 2,
        yOffset: 0,
      });
      setTooltipPos({
        transform: `translate(-${tooltipWidth - triggerWidth}px, -${tooltipHeight + triggerHeight + offset}px)`,
      });
      return;
    default:
      setTriggerPos({ placement: "top", xOffset: triggerCenter, yOffset: 0 });
      setTooltipPos({
        transform: `translateY(${offset}px)`,
      });
  }
}
